/**
 * Shared presentation constants for the operating-mode timeline + isolation
 * runner. Kept out of the component files so a mode keeps ONE colour across both
 * views and neither component file exports a non-component (fast-refresh safe).
 */

/** Distinct, theme-safe hues for mode segments (legible on both light and dark grounds). */
export const MODE_HUES = [22, 205, 152, 265, 190, 40, 214, 330];

/** The hue for a mode, by its position in the declared mode list. */
export function modeHue(modes: string[], mode: string): number {
  const i = modes.indexOf(mode);
  return MODE_HUES[(i < 0 ? 0 : i) % MODE_HUES.length];
}
